<div style="height: auto;">
    <app-header></app-header>
    <div class="container-fluid main">
        <div>
            <div class="container welcome-container">
                <div class="row p-1 header">
                    <div style="padding: 5px 20px">
                        <div class="welcome-user">Welcome! {{facility_name}}</div>
                        <button class="btn onboarded mb-2" type="button">{{userProfileStatus}}</button>
                    </div>
                    <!-- <div class="col-md-6 col-12">
                <div class="row">
                    <div class="col-6">

                    </div>
                    <div class="col-6">
                        <div>
                           <span style="display: inline-flex;">
                               CSE:
                               <h5 class="ms-2">La Midas Hospital</h5>
                           </span>
                       </div>
                        <div>
                           <span style="display: inline-flex;">
                               Helpline:
                               <h5 class="ms-2">0123 451 1111</h5>
                           </span>
                       </div>
                    </div>
                </div>
            </div> -->
                </div>
            </div>
            <div class="container mt-4 corousel-container"
                style="background-color: #ED1556ed;background-image: linear-gradient(to right, #ED1556ed , #C82C81);">
                <div id="carouselExampleControls" #carousel class="carousel" style="width:100%">
                    <div class="carousel-inner">
                        <div class="carousel-item" *ngFor="let el of carouselHeader; let i=index"
                            [ngClass]="(i === 0) ? 'active' : ''">
                            <div class="d-flex flex-row align-items-center">
                                <div class="col-2 col-md-1 ms-2 ms-sm-4 ms-md-5">
                                    <img class="target-img carousel-image" [src]="el?.imgPath" alt="Hospital Registered">
                                </div>
                                <div class="col-8 d-flex align-items-center carousel-text">
                                    <div style="color: white !important;">{{el?.text}}</div>
                                </div>
                                <div class="col-2 count text-center text-md-end" >
                                    <div style="color: white;">
                                        {{el?.count}}</div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="carousel-item">
                    <div class="row align-items-center" style="height: 93px;">
                        <div class="col-md-2 col-12 text-end">
                            <img class="target-img" src="../../../assets/images/Group 16739.svg"
                                alt="">
                        </div>
                        <div class="col-md-8 col-12">
                            <p style="color: white !important;">Hospitals Onboarded</p>
                        </div>
                        <div class="col-md-2 col-12">
                            <span>
                                <h2 style="color: white;">56</h2>
                            </span>
                        </div>
                    </div>
                </div> -->
                    </div>

                    <!-- Button to change the corousel -->
                    <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon leftIcon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon rightIcon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button> -->
                </div>

            </div>

            <!-- Registration -->

            <!-- <div class="navigation_menu" id="navigation_menu" style="margin-top: 25px; width: 100%">
        <ul class="navigation_tabs" id="navigation_tabs" style="width: 100%;">
            <li class="tab_inactive " style="width: 100%; padding-right: 26px;">
                <div class="container mt-3 registrationContainer" style="background-color: #E5FFE7;"
                    *ngFor="let item of registrationCard">
                    <div class="row py-3">
                        <div class="col-md-8 col-12">
                            <h4 style="color:#503794; font-weight:600">{{item?.title}}</h4>
                            <span>{{item?.registeredDate}}</span>
                            <p class="mt-2">
                                {{item?.description}}
                            </p>
                            <div class="row">
                                <div class="col-md-10 align-items-center">
                                    <div>
                                        <span>{{item?.percentage}}% Completed</span>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar"
                                                aria-valuenow="item?.percentage" aria-valuemin="0" aria-valuemax="100"
                                                [ngStyle]="{'width': item?.percentage+'%','background-color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 mt-1">
                                    <button type="button" class="btn status"
                                        [ngStyle]="{'width': 'max-content','color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">{{item?.status}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-12 text-end">
                            <button type="button" (click)="goToProfile()" class="btn gotoProfile">GO TO PROFILE</button>
                        </div>
                    </div>
                </div>
            </li>
            <li class="tab_active">
                <div class="container mt-3 p-1">
                    <div class="accordion accordionContainer" id="accordionPanelsStayOpenExample">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                    aria-controls="panelsStayOpen-collapseOne" style="color:black">
                                    <h3 style="font-weight:600">
                                        Manyata Journey
                                    </h3>
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                                aria-labelledby="panelsStayOpen-headingOne">
                                <div class="accordion-body">
                                    <div class="row align-items-center py-3" style="background: aliceblue;"
                                        *ngFor="let item of qualityImprovement">
                                        <div class="col-md-8 col-12">
                                            <h5 style="color:#503794; font-weight:600">{{item?.title}}</h5>
                                            <span>{{item?.registeredDate}}</span>
                                            <p class="mt-2">
                                                {{item?.description}}
                                            </p>
                                            <div class="row">
                                                <div class="col-md-10 align-items-center">
                                                    <div>
                                                        <span>{{item?.percentage}}% Completed</span>
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar"
                                                                aria-valuenow="item?.percentage" aria-valuemin="0"
                                                                aria-valuemax="100"
                                                                [ngStyle]="{'width': item?.percentage+'%','background-color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 mt-1">
                                                    <button type="button" class="btn status"
                                                        [ngStyle]="{'width': 'max-content','color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">{{item?.status}}</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-12 text-center">
                                            <img src="../../../assets/images/Next steps-pana(1).svg" class="img-fluid"
                                                alt="">
                                        </div>
                                    </div>
                                    <div class="row align-items-center py-3 mt-3" *ngFor="let item of qualityAssessment"
                                        style="background: white;border: 1px solid lightgray;">
                                        <div class="col-md-8 col-12">
                                            <h5 style="color:#503794; font-weight:600">{{item?.title}}</h5>
                                            <span>{{item?.registeredDate}}</span>

                                            <p class="mt-2">
                                                {{item?.description}}
                                            </p>
                                            <div class="row">
                                                <div class="col-md-10 align-items-center">
                                                    <div>
                                                        <span>{{item?.percentage}}% Completed</span>
                                                        <div class="progress inprogress">
                                                            <div class="progress-bar inprogress-bar" role="progressbar"
                                                                aria-valuenow="item?.percentage" aria-valuemin="0"
                                                                aria-valuemax="100"
                                                                [ngStyle]="{'width': item?.percentage+'%','background-color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 mt-1">
                                                    <button type="button" class="btn status"
                                                        [ngStyle]="{'width': 'max-content','color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">{{item?.status}}</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-12 text-center">
                                            <img src="../../../assets/images/Metrics-pana.svg" class="img-fluid" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div> -->


            <div class="navigation_menu" id="navigation_menu" style="margin-top: 25px; width: 100%;">
                <ul class="navigation_tabs" id="navigation_tabs" style="width: 97.4%;">
                    <li class="tab_inactive" style="width: 100%;">
                        <div class="container mt-3 registrationContainer" style="background-color: #E5FFE7;"
                            *ngFor="let item of registrationCard">
                            <div class="row py-3 px-3">
                                <div class="col-md-8 col-12">
                                    <h4 style="color:#503794; font-weight:600; font-family:Raleway">Registration</h4>
                                    <span style="font-family: raleway;" class="label">{{profileRegisteredDate}}</span>
                                    <!-- <p class="mt-2" style="font-family:Raleway">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                    laboris
                                    nisi ut aliquip ex ea commodo consequat.
                                </p> -->
                                    <div class="row">
                                        <div class="col-md-10 mt-4 align-items-center">
                                            <div>
                                                <span class="label">{{profileCompletion}}% Completed</span>
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar" aria-valuenow="100"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        [ngStyle]="{'width': profileCompletion+'%','background-color': profileCompletion < 100 ? '#EB996E' : '#19B123'}">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 mt-4">
                                            <button type="button" class="btn status mb-3"
                                                [ngStyle]="{'width': 'max-content','color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">{{profileStatus}}</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-end">
                                    <button type="button" (click)="goToProfile()" class="btn gotoProfile">GO TO
                                        PROFILE</button>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="tab_active" style="width: 100%; font-family:Raleway;">
                        <div class="container mt-3 p-0">
                            <div class="accordion accordionContainer mb-3" id="accordionPanelsStayOpenExample"
                                style="width: 100%;">
                                <div class="accordion-item">
                                    <div class="accordion-header px-1 pt-1" id="panelsStayOpen-headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                            aria-controls="panelsStayOpen-collapseOne" style="color:black">
                                            <h4 style="font-weight:600; font-family:Raleway">
                                                Manyata Journey
                                            </h4>
                                        </button>
                                    </div>
                                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show px-3"
                                        aria-labelledby="panelsStayOpen-headingOne">
                                        <div class="accordion-body pt-0">
                                            <div class="row align-items-center py-4 rounded-2"
                                                style="background: aliceblue;" *ngFor="let item of qualityImprovement">
                                                <div class="col-md-8 col-12">
<div>
    <h5 class="journey-title" style="color:#503794; font-weight:600">{{item?.title}}</h5>
    <!-- <span>{{item?.registeredDate}}</span> -->
    <p class="mt-2 label">
        {{item?.description}}
    </p>
</div>
                                                    <!-- <div class="row">
                                                        <div class="col-md-10 align-items-center">
                                                            <div>
                                                                <span>{{item?.percentage}}% Completed</span>
                                                                <div class="progress">
                                                                    <div class="progress-bar" role="progressbar"
                                                                        aria-valuenow="item?.percentage"
                                                                        aria-valuemin="0" aria-valuemax="100"
                                                                        [ngStyle]="{'width': item?.percentage+'%','background-color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 mt-1">
                                                            <button type="button" class="btn status"
                                                                [ngStyle]="{'width': 'max-content','color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">{{item?.status}}</button>
                                                        </div>
                                                    </div> -->
                                                </div>
                                                <div class="col-md-4 col-12 text-center">
                                                    <img src="../../../assets/images/Next steps-pana(1).svg"
                                                        class="img-fluid" alt="">
                                                </div>
                                            </div>

                                            <div class="row align-items-center py-4 mt-3 rounded-2"
                                                *ngFor="let item of qualityAssessment"
                                                style="background: white;border: 1px solid lightgray;">
                                                <div class="col-md-8 col-12">
                                                    <h5 class="journey-title" style="color:#503794; font-weight:600">{{item?.title}}</h5>
                                                    <!-- <span>{{item?.registeredDate}}</span> -->

                                                    <p class="mt-2 label">
                                                        {{item?.description}}
                                                    </p>
                                                    <!-- <div class="row">
                                                        <div class="col-md-10 align-items-center">
                                                            <div>
                                                                <span>{{item?.percentage}}% Completed</span>
                                                                <div class="progress inprogress">
                                                                    <div class="progress-bar inprogress-bar"
                                                                        role="progressbar"
                                                                        aria-valuenow="item?.percentage"
                                                                        aria-valuemin="0" aria-valuemax="100"
                                                                        [ngStyle]="{'width': item?.percentage+'%','background-color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 mt-1">
                                                            <button type="button" class="btn status"
                                                                [ngStyle]="{'width': 'max-content','color': item?.percentage < 100 ? '#EB996E' : '#19B123'}">{{item?.status}}</button>
                                                        </div>
                                                    </div> -->
                                                </div>
                                                <div class="col-md-4 col-12 text-center">
                                                    <img src="../../../assets/images/Metrics-pana.svg" class="img-fluid"
                                                        alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>


            <!-- <div class="mt-4 mb-5 exploreContainer">
                <div class="card border-0 shadow rounded-3" style="width:49%">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-md-9">
                                <div style="font-size:20px; font-weight:700;">Explore More</div>
                                <p>Lorem ipsum dolor sit amet, consectetur ae rcitation ullamco laboris nisi ut aliquip
                                    ex ea</p>
                                <button class="btn gotoProfile">EXPLORE MORE</button>
                            </div>
                            <div class="col-md-3">
                                <img src="../../../assets/images/Load more-rafiki.svg" class="img-fluid" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card border-0 shadow rounded-3" style="width:49%">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-md-9">
                                <div style="font-size:20px; font-weight:700;">Support/Feedback</div>
                                <p>Lorem ipsum dolor sit amet, consectetur ae rcitation ullamco laboris nisi ut aliquip
                                    ex ea</p>
                                <button class="btn gotoProfile">LEARN MORE</button>
                            </div>
                            <div class="col-md-3">
                                <img src="../../../assets/images/Contact us-pana.svg" class="img-fluid" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
<div>
    <app-footer></app-footer>
</div>